import styled, { css } from 'styled-components';
import { PlayLinkContainer } from '../../../../components/Link';
import { PlayLinkDiscreet } from '../../../PlayLink.styles';
import { PlayListHeaderPadding, PlayListHeading } from '../../../typography/PlayListHeading.styles';
import { playFontIcon } from '../../../typography/helpers';
import { playTransitionEasing, iconArrowRight } from '../../../design-tokens';
import { playFocus } from 'app/ui-components/utils.styles';

export const StyledHeader = styled.div`
    position: relative;
    z-index: 3;
`;

const getPadding = (noBottomPadding) => {
    if (noBottomPadding) {
        return css`
            padding: 10px 10px 0 0;
        `;
    }

    return css`
        ${PlayListHeaderPadding}
    `;
};

export const Heading = styled(PlayListHeading)`
    text-overflow: ellipsis;
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    ${(props) => getPadding(props.noBottomPadding)}
    display: block;
    float: left;
    box-sizing: border-box;
    margin: 0;
`;

export const BumpingArrowIcon = styled.span`
    line-height: normal;
    text-decoration: none;
    margin-left: 5px;
    vertical-align: middle;
    font-size: 1em;
    margin-top: -1px;

    &:before {
        ${playFontIcon(2, iconArrowRight)}
        transition: transform 200ms ${playTransitionEasing};
        vertical-align: baseline;
    }
`;

export const Link = styled(PlayLinkContainer)`
    ${PlayLinkDiscreet};

    &:hover {
        text-decoration: underline;
        cursor: pointer;

        ${BumpingArrowIcon} {
            &:before {
                transform: translateX(4px);
            }
        }
    }
`;

export const RemoveItemsButton = styled.button`
    ${playFocus()}
    padding: 8px 2px;
    border: none;
    background: transparent;
    right: 4px;
    top: 13px;
    display: block;
    position: absolute;
    min-width: 100px;

    &:hover {
        cursor: pointer;
    }
`;

export const RemoveItemsButtonTransition = styled.span`
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
    transform-origin: right;
    text-align: right;

    &.enter {
        display: block;
        opacity: 0;
        transform: scale(0.8) translateY(20px);
        position: absolute;
        right: 0;
        top: 0;
        width: 100px;
    }

    &.enter-active {
        opacity: 1;
        transform: scale(1) translateY(0);
        transition: all 150ms ease-in;
    }

    &.exit {
        display: block;
        opacity: 1;
        transform: scale(1) translateY(0);
        position: absolute;
        right: 0;
        top: 0;
        width: 100px;
    }

    &.exit-active {
        opacity: 0;
        transform: scale(0.8) translateY(-20px);
        transition: all 150ms ease-in;
    }
`;
